<div class="container"  [class.icon-first]="isIconFirst" [class.disable]="isButtonDisabled" [class.active]="isActive" (click)="clickOnButton.emit()" (selectstart)="$event.preventDefault()"  (mousedown)="$event.preventDefault()">
  <button class="button2-impaired" [style.text-align]="buttonNameCenter ? 'center' : ''">
    {{ buttonName }}
  </button>
  <div [ngClass]="classSize" class="icon-container">
    <svg [class.rotate180]="isRotate180" [icon]="iconName" class="icon" [ngClass]="classSize"></svg>
  </div>
</div>
